<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('vincular-produto') }}
                    </h1>
                </div>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="produtosSelecionados.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    :tooltipLabel="
                        $t('msg-campo-busca-n', { n: $t('codigo') + ', ' + $t('produto') })
                    "
                />
            </div>
        </div>

        <div class="columns">
            <div class="column is-3">
                <vss-select
                    :id="generateId(1)"
                    v-model="grupoSelected"
                    title="produto-grupo-produto"
                    :options="grupoSelect"
                    :loading="grupoLoading"
                    @search="carregarGrupos"
                    multiple
                    searchable
                    clearable
                    :closeOnSelect="false"
                />
            </div>
            <div class="column is-3">
                <vss-select
                    :id="generateId(2)"
                    v-model="subGrupoSelected"
                    title="produto-subgrupo-produto"
                    :options="subGrupoSelect"
                    :loading="subGrupoLoading"
                    @search="carregarSubGrupos"
                    multiple
                    searchable
                    clearable
                    :closeOnSelect="false"
                />
            </div>
            <div class="column is-3">
                <vss-select
                    :id="generateId(3)"
                    v-model="marcaSelected"
                    title="produto-marca"
                    :options="marcaSelect"
                    :loading="marcaLoading"
                    @search="carregarMarca"
                    multiple
                    searchable
                    clearable
                    :closeOnSelect="false"
                />
            </div>
            <div class="column is-3">
                <vss-select
                    :id="generateId(4)"
                    v-model="familiaSelected"
                    title="familia"
                    :options="familiaSelect"
                    :loading="familiaLoading"
                    @search="carregarFamilia"
                    multiple
                    searchable
                    clearable
                    :closeOnSelect="false"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="produtos"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="produtosSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.id === linha.id"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div>
                        <router-link
                            v-if="props.row[f.columnId]"
                            :to="{
                                name: f.redirectName,
                                params: {
                                    id: props.row[f.columnId],
                                },
                                query: { tela: 'motivo-atendimento', id: $route.params.id },
                            }"
                        >
                            {{ isNull(props.row[f.key]) ? '--' : props.row[f.key] }}
                        </router-link>
                        <p v-else>
                            {{ isNull(props.row[f.key]) ? '--' : props.row[f.key] }}
                        </p>
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        idempresa: 0,
    },
    data() {
        return {
            produtos: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: '7.5%', sortable: true, sortFn: null },
                {
                    redirectName: 'ven-produto-edit',
                    columnId: 'id',
                    key: 'produto',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                {
                    redirectName: 'ven-produto-grupo-edit',
                    columnId: 'idGrupo',
                    key: 'grupo',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                {
                    redirectName: 'ven-produto-sub-grupo-edit',
                    columnId: 'idSubGrupo',
                    key: 'subGrupo',
                    width: 120,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'marca', width: null, sortable: true, sortFn: null },
                { key: 'familia', width: null, sortable: true, sortFn: null },
            ],
            produtosSelecionados: [],
            idproduto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'codigo',
            order: 'asc',
            msgs: [],
            grupoLoading: false,
            grupoSelect: [],
            grupoSelected: [],
            debouncedSearchGrupo: null,

            subGrupoLoading: false,
            subGrupoSelect: [],
            subGrupoSelected: [],
            debouncedSearchSubGrupo: null,

            marcaLoading: false,
            marcaSelect: [],
            marcaSelected: [],
            debouncedSearchMarca: null,

            familiaLoading: false,
            familiaSelect: [],
            familiaSelected: [],
            debouncedSearchFamilia: null,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedSearchGrupo = this.debounce(this.onSearchGrupo, 500);
        this.debouncedSearchSubGrupo = this.debounce(this.onSearchSubgrupo, 500);
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    watch: {
        grupoSelected: {
            handler() {
                this.carregarDados();
            },
            deep: true,
        },
        subGrupoSelected: {
            handler() {
                this.carregarDados();
            },
            deep: true,
        },
        marcaSelected: {
            handler() {
                this.carregarDados();
            },
            deep: true,
        },
        familiaSelected: {
            handler() {
                this.carregarDados();
            },
            deep: true,
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-produto-' + numberId;
        },
        save() {
            this.isLoading = true;

            const requestBody = this.produtosSelecionados.map(({ id }) => ({
                idCrmMotivoAtendimento: this.$route.params.id,
                produto: {
                    idproduto: id,
                },
            }));

            this.$axios
                .post(`assMotivoAtendimentoProduto`, requestBody)
                .then((_) => {
                    this.$emit('fecharModal', true);
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            const idsGrupo = this.grupoSelected.map(({ id }) => id);
            const idsSubGrupo = this.subGrupoSelected.map(({ id }) => id);
            const idsMarca = this.marcaSelected.map(({ id }) => id);
            const idsFamilia = this.familiaSelected.map(({ id }) => id);

            const body = {
                idsGrupo,
                idsSubGrupo,
                idsMarca,
                idsFamilia,
            };

            this.$axios
                .post(
                    `/sales/product/findAll/naoVinculadoMotivoAtendimento/${this.$route.params.id}`,
                    body,
                    {
                        params: {
                            column: this.column,
                            order: this.order,
                            page: currentPage - 1,
                            limit: this.pagination.perPage,
                            ids: this.idempresa,
                            param: this.queryFilter,
                        },
                    }
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtos = value;
                    this.isEmpty = this.produtos.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        carregarGrupos(searchQuery) {
            this.grupoLoading = true;

            this.$axios
                .get('/product/getcombo/group.json', {
                    params: {
                        param: searchQuery,
                    },
                })
                .then(this.mapDefaultSelect)
                .then((mappedResponse) => (this.grupoSelect = mappedResponse))
                .catch((err) => {
                    console.error(err);
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(() => {
                    this.grupoLoading = false;
                });
        },
        carregarSubGrupos(searchQuery) {
            this.subGrupoLoading = true;

            this.$axios
                .get('/promotor/getcombo/subgrupoproduto.json', {
                    params: {
                        param: searchQuery,
                    },
                })
                .then(this.mapDefaultSelect)
                .then((mappedResponse) => (this.subGrupoSelect = mappedResponse))
                .catch((err) => {
                    console.error(err);
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(() => {
                    this.subGrupoLoading = false;
                });
        },
        carregarMarca(searchQuery) {
            this.marcaLoading = true;

            this.$axios
                .get('/promotor/getcombo/marca.json', {
                    params: {
                        param: searchQuery,
                    },
                })
                .then(this.mapDefaultSelect)
                .then((mappedResponse) => (this.marcaSelect = mappedResponse))
                .catch((err) => {
                    console.error(err);
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(() => {
                    this.marcaLoading = false;
                });
        },
        carregarFamilia(searchQuery) {
            this.familiaLoading = true;

            this.$axios
                .get('/produtofamilia/list-combo.json', {
                    params: {
                        param: searchQuery,
                    },
                })
                .then(this.mapDefaultSelect)
                .then((mappedResponse) => (this.familiaSelect = mappedResponse))
                .catch((err) => {
                    console.error(err);
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(() => {
                    this.familiaLoading = false;
                });
        },
        mapDefaultSelect(comboResponse) {
            return comboResponse.data.content.map(({ id, descricao: label }) => ({
                id,
                label,
            }));
        },
        mapItems(body) {
            const { data } = body;
            this.pagination.totalRows = data.totalElements;
            return data.content.map((produto) => {
                return {
                    codigo: produto.idprodutoerp,
                    id: produto.idproduto,
                    produto: produto.descricao,
                    idGrupo: produto.grupoproduto ? produto.grupoproduto.idgrupoproduto : null,
                    grupo: produto.grupoproduto ? produto.grupoproduto.descricao : null,
                    idSubGrupo: produto.subgrupoproduto
                        ? produto.subgrupoproduto.idsubgrupoproduto
                        : null,
                    subGrupo: produto.subgrupoproduto ? produto.subgrupoproduto.descricao : null,
                    idMarca: produto.idmarca,
                    marca: produto.marca,
                    idFamilia: produto.produtoFamilia ? produto.produtoFamilia.idfamilia : null,
                    familia: produto.produtoFamilia ? produto.produtoFamilia.descricao : null,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>
